import { render, staticRenderFns } from "./MaterialActions.vue?vue&type=template&id=b489bad2&scoped=true"
import script from "./MaterialActions.vue?vue&type=script&lang=js"
export * from "./MaterialActions.vue?vue&type=script&lang=js"
import style0 from "./MaterialActions.vue?vue&type=style&index=0&id=b489bad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b489bad2",
  null
  
)

export default component.exports